/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Escritorio } from '../models/escritorio';
import { Devedor } from '../models/devedor';
import { Message } from '../models/message';

/**
 * API responsavel pelos dados dos escritorios
 */
@Injectable({
  providedIn: 'root',
})
class EscritoriosService extends __BaseService {
  static readonly obterEscritoriosPath = '/escritorios/{nomeEscritorio}/{codigoRamoSinistro}';
  static readonly obterEscritorioPagadorPath = '/escritorios/pagador/{codigoEscritorio}/{codigoRamoSinistro}';
  static readonly salvarEscritorioPath = '/escritorios';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera todos os registros do cadastro de escritorios que ja realizaram acordos na ferramenta
   * @param params The `EscritoriosService.ObterEscritoriosParams` containing the following parameters:
   *
   * - `nomeEscritorio`: Parte do nome do Escritorio
   *
   * - `codigoRamoSinistro`: Codigo Ramo Sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterEscritoriosResponse(params: EscritoriosService.ObterEscritoriosParams): __Observable<__StrictHttpResponse<Array<Escritorio>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/escritorios/${encodeURIComponent(String(params.nomeEscritorio))}/${encodeURIComponent(String(params.codigoRamoSinistro))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Escritorio>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de escritorios que ja realizaram acordos na ferramenta
   * @param params The `EscritoriosService.ObterEscritoriosParams` containing the following parameters:
   *
   * - `nomeEscritorio`: Parte do nome do Escritorio
   *
   * - `codigoRamoSinistro`: Codigo Ramo Sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterEscritorios(params: EscritoriosService.ObterEscritoriosParams): __Observable<Array<Escritorio>> {
    return this.obterEscritoriosResponse(params).pipe(
      __map(_r => _r.body as Array<Escritorio>)
    );
  }

  /**
   * Recupera os dados de um escritorio
   * @param params The `EscritoriosService.ObterEscritorioPagadorParams` containing the following parameters:
   *
   * - `codigoRamoSinistro`: Codigo Ramo Sinistro
   *
   * - `codigoEscritorio`: Parte do nome do Escritorio
   *
   * @return Operacao realizada com sucesso
   */
  obterEscritorioPagadorResponse(params: EscritoriosService.ObterEscritorioPagadorParams): __Observable<__StrictHttpResponse<Devedor>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/escritorios/pagador/${encodeURIComponent(String(params.codigoEscritorio))}/${encodeURIComponent(String(params.codigoRamoSinistro))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Devedor>;
      })
    );
  }
  /**
   * Recupera os dados de um escritorio
   * @param params The `EscritoriosService.ObterEscritorioPagadorParams` containing the following parameters:
   *
   * - `codigoRamoSinistro`: Codigo Ramo Sinistro
   *
   * - `codigoEscritorio`: Parte do nome do Escritorio
   *
   * @return Operacao realizada com sucesso
   */
  obterEscritorioPagador(params: EscritoriosService.ObterEscritorioPagadorParams): __Observable<Devedor> {
    return this.obterEscritorioPagadorResponse(params).pipe(
      __map(_r => _r.body as Devedor)
    );
  }

  /**
   * Cadastra um escritorio
   * @param escritorio Objeto do escritorio
   * @return Operacao realizada com sucesso
   */
  salvarEscritorioResponse(escritorio: Devedor): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = escritorio;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/escritorios`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cadastra um escritorio
   * @param escritorio Objeto do escritorio
   * @return Operacao realizada com sucesso
   */
  salvarEscritorio(escritorio: Devedor): __Observable<Message> {
    return this.salvarEscritorioResponse(escritorio).pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module EscritoriosService {

  /**
   * Parameters for obterEscritorios
   */
  export interface ObterEscritoriosParams {

    /**
     * Parte do nome do Escritorio
     */
    nomeEscritorio: string;

    /**
     * Codigo Ramo Sinistro
     */
    codigoRamoSinistro: number;
  }

  /**
   * Parameters for obterEscritorioPagador
   */
  export interface ObterEscritorioPagadorParams {

    /**
     * Codigo Ramo Sinistro
     */
    codigoRamoSinistro: number;

    /**
     * Parte do nome do Escritorio
     */
    codigoEscritorio: number;
  }
}

export { EscritoriosService }
